import FinanceReport from "./index";
import FinanceOrder from "./FinanceOrder";
import FinanceBill from  './FinanceBill'
import FinanceBalance from './FinanceBalance'
import FinanceTrade from './FinanceTrade'
import AddressBalance from './AddressBalance'


export default {
  path: "/home/financeReport",
  component: FinanceReport,
  children: [
    { path: "/home/financeReport/financeOrder", component: FinanceOrder },
    { path: "/home/financeReport/financeBill", component: FinanceBill },
    { path: "/home/financeReport/financeBalance", component: FinanceBalance },
    { path: "/home/financeReport/financeTrade", component: FinanceTrade },
    { path: "/home/financeReport/addressBalance", component: AddressBalance },
  ],
};
